// features/petForm/petFormSlice.js
// Slice for the forms comtrol. Using in form components - Onboarding, User account - editPet.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mode: 'add', // 'add' | 'edit'
  data: {
    id: '',
    name: '',
    gender: '',
    birthday: '',
    type: '',
    breed: '',
    photo: '',
  },
};

export const petFormSlice = createSlice({
  name: 'petForm',
  initialState,
  reducers: {
    setFormMode: (state, action) => {
      state.mode = action.payload; // 'add' or 'edit'
    },
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.data[field] = value;
    },
    setFormData: (state, action) => {
      state.data = action.payload; // for loading pet data from petsSlice for editing
    },
    resetForm: (state) => {
      state.mode = 'add';
      state.data = {
        id: '',
        name: '',
        gender: '',
        birthday: '',
        type: '',
        breed: '',
        photo: '',
      };
    },
  },
});

export const {
  setFormMode,
  updateFormField,
  setFormData,
  resetForm,
} = petFormSlice.actions;

export const selectPetForm = (state) => state.petForm;
export const selectPetFormData = (state) => state.petForm.data;
export const selectPetFormMode = (state) => state.petForm.mode;

export default petFormSlice.reducer;
